import { IEventNote } from 'data/entities/event/event-note';

export const EVENT_NOTE_TYPES = ['guest comment', 'internal', 'channel comment', 'internal finance'];

export const formatTimeStamp = (timeStamp: string) => {
	if (isNaN(Date.parse(timeStamp))) {
		return '';
	}

	const dt = new Date(timeStamp);
	const mins = dt.getMinutes();
	return `${dt.toDateString()} at ${dt.getHours()}:${mins < 10 ? '0' : ''}${mins}`;
};

export const formatNote = (noteType: string, noteContent: string) => {
	if (noteType === 'email event') {
		// Format: "[Event|type=Email Sent|templateId=owner_booking_confirmation|date=2020-03-04T09:27:55.561Z|
		// cancellation_policy=bookingcom_fully_non_refundable] Sent Booking Confirmation to owner"
		const event = noteContent.replace(/\[(.*)\] (.*)/g, '$1');
		const message = noteContent.replace(/\[(.*)\] (.*)/g, '$2');

		if (event !== noteContent) {
			const eventFields = event.split('|');
			// const type = eventFields[1];
			// const templateId = eventFields[2];
			// const dt = eventFields[3];
			const subject = (eventFields.length > 4) ? (': ' + eventFields[4]) : '';

			return message + subject;
		}
	}

	return noteContent;
};

export const canDeleteNote = (note: IEventNote) => {
	return (note.note_type !== 'audit')
		&& (note.note_type !== 'email event')
		&& (note.note_type !== 'preload')
		&& (note.note_type !== 'payment')
		&& (note.note_type !== 'refund')
		&& (note.note_type !== 'cancellation_policy');
};

export const validateNoteLength = (
	input: string,
	minLength: number,
	maxLength: number) => (input.length > minLength) && (input.length < maxLength);
